import { http } from 'http';

export default {
  uploadDocument: ({ folder, docType, file }) =>
    http.post(`/actas/devolucion/docs/${folder}/${docType}`, file, {
      headers: { 'content-type': 'multipart/form-data' }
    })
};
